/**
 * CUÁNTOS ALIMENTOS SE ENSEÑAN EN «LO HAGO YO» (Jesús, 27-09, audios de las 21:44 y 21:54).
 *
 * «En lugar de salir todos esos tantos elementos, que salgan menos, que salga luego un más, y
 * que debajo yo pueda ir viendo lo que voy añadiendo»; y a las 21:54: «que me salgan, por
 * ejemplo, tres la primera vez, mostrar más». Siempre los primeros `CUANTOS` y «Mostrar más»,
 * también con la comida vacía. Buscando no se recorta: quien escribe quiere ver todo.
 */
export const CUANTOS = 3;

export const alimentosVisibles = (lista, { buscando, verTodos } = {}) => {
    const todos = lista || [];
    const recortar = !buscando && !verTodos && todos.length > CUANTOS;
    return {
        visibles: recortar ? todos.slice(0, CUANTOS) : todos,
        ocultos: recortar ? todos.length - CUANTOS : 0,
    };
};

export default alimentosVisibles;
